import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import GoogleIcon from "@mui/icons-material/Google";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import { Box } from "@mui/material";
import Link from "next/link";

import { theme } from "../../mui-customs/Theme";
import Typography from "../Typography";
import FooterIcon from "./FooterIcon";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        py: 8,
        backgroundColor: theme.brand1[500],
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "4px",
        display: { xs: "none", md: "flex" },
        "& a": {
          color: theme.grey1[300],
          ":hover": {
            color: theme.grey1[400],
          },
        },
      }}
    >
      <Box sx={{ display: "flex", gap: "20px", mb: "30px" }}>
        <FooterIcon Icon={FacebookOutlinedIcon} />
        <FooterIcon Icon={PinterestIcon} />
        <FooterIcon Icon={GoogleIcon} />
        <FooterIcon Icon={InstagramIcon} />
      </Box>
      <Typography
        variant="body3"
        sx={{
          color: theme.whiteBg.WBG1,
          maxWidth: "900px",
          width: "90%",
          textAlign: "center",
          pb: 1,
          fontFamily: "Montserrat !important",
          fontSize: "9px !important",
          fontWeight: "300 !important",
        }}
      >
        © 2025 More Pleaze. More Pleaze LLC provides private chef referrals,
        information and education. Our services are not medical, mental health,
        financial, business or legal advice. More Pleaze LLC chefs are private
        chefs, not licensed medical or licensed mental health professionals.
        Nothing on our website, its content or in our services is intended to
        diagnose, treat, heal, cure or prevent any illness, medical condition or
        mental condition. Anyone choosing to implement any information on our
        website or in our Services should obtain prior medical clearance from a
        licensed medical or mental health professional to declare them
        sufficiently healthy, and determine that the information on our website
        or in our services is appropriate and useful for them. Do not disregard
        professional medical advice or delay seeking professional advice because
        of information you have read on our website, or received from us. You
        are encouraged to consult with a licensed business professional. More
        Pleaze LLC does not guarantee that you will obtain any results or earn
        any money using our content. Nothing on our website or in our Services
        is a guarantee or promise of future earnings. We do not provide
        investment recommendations, investment counseling, accounting services
        or tax advice. All of the Content on morepleaze.com and included in our
        Services, unless clearly stated otherwise, is solely owned by More
        Pleaze LLC and is protected by United States and international
        copyright, trademark and other intellectual property laws, which
        prohibit its unauthorized use. You agree not to copy, reproduce,
        duplicate, modify, publish, transmit, replicate on another website,
        create derivative works from, sell, assist in the sale of, distribute,
        display, perform, or in any other way, exploit our content or any of our
        intellectual property, in whole or in part, whether manually or by
        electronic means, whether or not you have purchased such information,
        without the express written consent of More Pleaze LLC.
      </Typography>
      <Link href="http://morepleaze.com/disclaimer/">
        <a style={{}} target="_blank">
          <Typography
            variant="body3"
            sx={{
              color: theme.whiteBg.WBG1,
              textAlign: "center",
              fontFamily: "Montserrat !important",
              fontSize: "9px !important",
            }}
          >
            Disclaimer
          </Typography>
        </a>
      </Link>
      <Link href="https://morepleaze.com/privacy-policy/">
        <a style={{}} target="_blank">
          <Typography
            variant="body3"
            sx={{
              color: theme.whiteBg.WBG1,
              textAlign: "center",
              fontFamily: "Montserrat !important",
              fontSize: "9px !important",
            }}
          >
            Privacy Policy
          </Typography>
        </a>
      </Link>
      <Link href="https://morepleaze.com/terms-and-conditions/">
        <a target="_blank">
          <Typography
            variant="body3"
            sx={{
              color: theme.whiteBg.WBG1,
              textAlign: "center",
              fontFamily: "Montserrat !important",
              fontSize: "9px !important",
            }}
          >
            Terms and Conditions
          </Typography>
        </a>
      </Link>
    </Box>
  );
};

export { Footer };
